<tc-quick-action
        *ngIf="!hideQuickActions"
        (actionClick)="onActionClick($event)"
        [actions]="actions">
</tc-quick-action>
